import {IStickerItem, IStickerItemsState} from "./reducer";
import {FetchStatus} from "../stickers/reducer";

export const stickerItemsStateSelector = (state: any): IStickerItemsState => state.stickers.entities.stickerItems;

export const stickerItemsSelector = (state: any, stickerItemId: string[] | null): IStickerItem[] | null => {
    const stickerItemsState = stickerItemsStateSelector(state);
    return stickerItemId && stickerItemId.map(id => stickerItemsState.byId[id])
};

export const stickerItemsFetchStatusSelector = (state: any, stickerItemId: string): FetchStatus => {
    const stickersItemsState = stickerItemsStateSelector(state);
    return stickersItemsState.fetchState[stickerItemId]?.status || 'idle';
};

export const stickerItemsFetchStateSelector = (state: any, stickerItemId: string): [FetchStatus, Error | null] => {
    const stickersItemsState = stickerItemsStateSelector(state);
    const status = stickersItemsState.fetchState[stickerItemId]?.status || 'idle';
    const error = stickersItemsState.fetchState[stickerItemId]?.error || null;
    return [status, error]
};

export const stickerItemSelector = (state: any, stickerItemId: string): IStickerItem | null  => {
    const item = stickerItemsSelector(state, [stickerItemId]);
    return item && item[0]
}


